import {HTML5Backend} from 'react-dnd-html5-backend';
import {DndProvider} from 'react-dnd';

const DragAndDropContext = Component => {
  const WithDragAndDropContext = props => (
    <DndProvider backend={HTML5Backend}>
      <Component {...props}/>
    </DndProvider>
  );

  WithDragAndDropContext.displayName = `DragAndDropContext(${Component.displayName || Component.name || 'Component'})`;

  return WithDragAndDropContext;
};

export default DragAndDropContext;
